import {
  PlanMonthlyScheduleState,
  PlanMonthlyScheduleAction,
  PlanMonthlyScheduleActionTypes as ActionTypes,
} from './types';

/**
 * @summary 月次計画画面で管理されるStateの初期値
 */
const initialPlanMonthlyScheduleState: PlanMonthlyScheduleState = {
  refresh: {},
  /** Load中か */
  isLoading: false,
  /** 月次スケジュールの個別取得中か */
  isTargetPlanLoading: false,
  /** 送信処理中か */
  isSubmitting: false,
  /** ソート番号 */
  sort: 1,
  /** 詳細検索条件 */
  searchParameter: {},
  /** 月次計画リスト */
  plans: [],
  /** 月次計画サマリ */
  summary: null,
  /** 月次計画祝日リスト */
  holidays: [],
  /** 月次個別計画 */
  targetPlan: null,
};

const planMonthlyScheduleReducer = (
  state: PlanMonthlyScheduleState = initialPlanMonthlyScheduleState,
  action: PlanMonthlyScheduleAction,
): PlanMonthlyScheduleState => {
  switch (action.type) {
    case ActionTypes.INIT:
      return initialPlanMonthlyScheduleState;

    case ActionTypes.REFRESH:
      return { ...state, refresh: {} };

    case ActionTypes.LOADING:
      return { ...state, isLoading: action.payload };

    case ActionTypes.TARGET_PLAN_LOADING:
      return { ...state, isTargetPlanLoading: action.payload };

    case ActionTypes.SUBMITTING:
      return { ...state, isSubmitting: action.payload };

    case ActionTypes.SET_SORT:
      return { ...state, sort: action.payload };

    case ActionTypes.SET_SEARCH_PARAMETER:
      return { ...state, searchParameter: action.payload };

    case ActionTypes.SET_PLANS:
      return { ...state, plans: action.payload };

    case ActionTypes.SET_SUMMARY:
      return { ...state, summary: action.payload };
    
    case ActionTypes.SET_HOLIDAYS:
      return { ...state, holidays: action.payload };

    case ActionTypes.SET_TARGET_PLAN:
      return { ...state, targetPlan: action.payload };

    default:
      return state;
  }
};

export default planMonthlyScheduleReducer;
